import React from 'react';
import styled from 'styled-components';

const StyledSection = styled.section`
  font-family: 'Poppins, sans-serif';

  .overlay {
    position: relative;
    background: linear-gradient(
      135deg,
      ${({ landingPrimaryColor }) => landingPrimaryColor || '#150080'} 0%,
      #6a0dad 100%
    );
    color: #fff;
    padding: 80px 0;
    text-align: center;
    overflow: hidden;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: ${({ landingPrimaryColor }) => landingPrimaryColor || '#150080'};
      opacity: 0.2;
      z-index: 0;
    }

    .content {
      position: relative;
      z-index: 1;

      h2 {
        margin: 10px 0;
        font-size: 28px;
        font-weight: 600;
      }
    }
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const Col = styled.div`
  flex: 1 0 100%;
  max-width: 100%;

  @media(min-width: 768px) {
    flex: 0 0 80%;
    max-width: 80%;
  }
`;

const Contact = ({ landingPrimaryColor, appPhoneNumber }) => {
  if (!appPhoneNumber) return null;

  return (
    <StyledSection landingPrimaryColor={landingPrimaryColor}>
      <div className="overlay">
        <Container>
          <Row>
            <Col>
              <div className="content">
                <h2>Do you have any questions?</h2>
                <h2>Please feel free to reach us @</h2>
                <h2>+91 {appPhoneNumber}</h2>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </StyledSection>
  );
};

export default Contact;
